import React from 'react';

import { ArrowButton, ArrowDirection } from './ArrowButton';

export function ArrowButtonPair({
    onArrowClick,
    isLeftEdge,
    isRightEdge,
    variant,
    size,
    dataTestPrefix = 'desktop-mortgage-calculator-arrow',
    isDisabledToHide,
}: {
    onArrowClick(type: ArrowDirection): void;
    isLeftEdge?: boolean;
    isRightEdge?: boolean;
    dataTestPrefix?: string;
} & Pick<React.ComponentProps<typeof ArrowButton>, 'variant' | 'size' | 'isDisabledToHide'>) {
    return (
        <>
            <ArrowButton
                direction='left'
                size={size}
                variant={variant}
                disabled={isLeftEdge}
                onClick={onArrowClick}
                dataTest={`${dataTestPrefix}-left`}
                isDisabledToHide={isDisabledToHide}
            />
            <ArrowButton
                direction='right'
                size={size}
                variant={variant}
                disabled={isRightEdge}
                onClick={onArrowClick}
                dataTest={`${dataTestPrefix}-right`}
                isDisabledToHide={isDisabledToHide}
            />
        </>
    );
}
